const extractTextFromHTML = (htmlString) => {
    const parser = new DOMParser();
    const parsedDocument = parser.parseFromString(htmlString, 'text/html');
    const paragraphs = Array.from(parsedDocument.body.querySelectorAll('p'));

    return paragraphs.map((p) => p.textContent).join('\n\n') || '';
}

export default extractTextFromHTML;